import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
// Bootstrap component
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';


// Assets
import './SurveyCompletePage.css';

 class SaveLater extends Component {
    state = {
        show:false
    }

    handleOpen = () => {
        this.setState({show:!this.state.show})
    }

    handleClose = () => {
        this.setState({show:false});
    }
    render() {
        const { totalQuestionCount, isRequiredCount, answeredQuestion, unAnsweredCount, instrumentList, naCount } = this.props;
        return (
            <Fragment>
                <Container>
                    <Row>
                        <Col md="2"></Col>
                        <Col md="8" className="survey-complete-heading">
                            <strong>
                                {instrumentList.saveLaterPageHeading.label}
                            </strong>
                        </Col>
                        <Col md="2"></Col>
                    </Row>
                    <Row>
                        <Col md="2"></Col>
                        <Col md="8" className="survey-complete-save-later-sub-heading">
                            <p> {instrumentList.saveLaterPageSubHeading.label}</p>
                        </Col>
                        <Col md="2"></Col>
                    </Row>
                    <Row>
                        <Col md="4"></Col>
                        <Col md="4" className="text-center">
                            {answeredQuestion === totalQuestionCount ? <Button className="submit-button"  
                                >{instrumentList.submitButtonText.label}</Button>:
                                <Button className="submit-button-disabled"
                                >{instrumentList.submitButtonText.label}</Button>}
                        </Col>
                        <Col md="4"></Col>
                    </Row>
                    <Row>
                        <Col md="3"></Col>
                        <Col md="6" className="text-center">
                        <Row>
                               <Col md="6" className="card-content">
                                    <Card className="text-left">
                                        <Card.Body>
                                            <Card.Title className="text-center">
                                                <span className="circle-success"></span>
                                            </Card.Title>
                                            <Card.Text className="text-center card-success-label">
                                                <strong>{answeredQuestion || 0}</strong> are <strong>complete</strong>
                                            </Card.Text>
                                            <Card.Text className="text-center card-na-label">
                                                {naCount !== 0 ? <><strong>{naCount}</strong> is <strong> n/a</strong></>:null}
                                            </Card.Text>
                                        </Card.Body>
                                        <Card.Text className="text-center card-link-label">
                                            <strong onClick={() => this.props.openModal("answered", true)}>{instrumentList.finishPageCompleteLinkText.label}</strong>
                                        </Card.Text>
                                    </Card>
                               </Col>
                               <Col md="6" className="card-content">
                                    <Card className="text-left">
                                        <Card.Body>
                                            <Card.Title className="text-center">
                                                <span className={ isRequiredCount !== 0 ? "circle-required" : "circle-danger"}></span>
                                            </Card.Title>
                                            <Card.Text className="text-center card-unanswered-label">
                                                <strong>{unAnsweredCount || 0}</strong> are <strong>unanswered</strong>
                                            </Card.Text>
                                            <Card.Text className="text-center card-required-label">
                                                <strong>{ isRequiredCount !== 0 ? isRequiredCount: null}</strong>
                                                { isRequiredCount !== 0 ? " is ": null}<strong>{ isRequiredCount !== 0 ? " required": null}</strong>
                                            </Card.Text>
                                        </Card.Body>
                                        <Card.Text className="text-center card-link-label">
                                            {answeredQuestion !== totalQuestionCount ? <strong onClick={() => this.props.openModal("unanswered", true)}>{instrumentList.finishPageUnansweredLinkText.label}</strong> :null}
                                        </Card.Text>
                                    </Card>
                               </Col>
                           </Row>
                        </Col>
                        <Col md="3"></Col>
                    </Row>
                    <Row>
                        <Col md="3"></Col>
                            <Col md="6" className="text-center">
                                <Button className="review-response-btn" onClick={() => this.props.openModal("review", false)}>
                                    {instrumentList.finishPageReviewButton.label}
                                </Button>
                            </Col>
                        <Col md="3"></Col>
                    </Row>
                </Container>
            </Fragment>
        )
    }
}

const mapStateToProps = state => ({
    itemList:state.survey.itemList,
    instrumentList:state.survey.instrument,
});

export default connect(mapStateToProps)(SaveLater);
